/**
 * @generated SignedSource<<fec0f95b3a762c7742f52ba4967e680d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFollowTopButton_viewer$data = {
  readonly followSearchRedesign: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_viewer">;
  readonly " $fragmentType": "SharedFollowTopButton_viewer";
};
export type SharedFollowTopButton_viewer$key = {
  readonly " $data"?: SharedFollowTopButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFollowTopButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFollowTopButton_viewer",
  "selections": [
    {
      "alias": "followSearchRedesign",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "followSearchRedesign"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"followSearchRedesign\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1de22b2b9123b6b5e743dd9cd358e950";

export default node;
